<div class="comment-input">
  <div class="avatar avatar--current">
    <img *ngIf="userAvatarUrl" [src]="userAvatarUrl" alt="" class="avatar__img" />
    <span *ngIf="!userAvatarUrl" class="avatar__initials">{{ userInitials }}</span>
  </div>

  <div class="input-wrapper">
    <textarea
      #commentTextarea
      class="input-field"
      [formControl]="commentControl"
      [placeholder]="
        isEditMode ? ('translations.comments.actions.editComment' | transloco) : ('translations.comments.actions.addComment' | transloco)
      "
      [rows]="1"
      (focus)="onFocus()"
      (keydown.escape)="onEscape()"
      (keydown.enter)="onEnterKey($event)"
      (input)="onInput()"
    ></textarea>

    <div class="input-footer">
      <button
        class="post-btn"
        type="button"
        (click)="onSubmit()"
        [disabled]="commentControl.invalid || isLoading"
        [attr.aria-label]="'translations.global.button.send' | transloco"
      >
        {{ isEditMode ? ('translations.global.button.save' | transloco) : ('translations.comments.actions.post' | transloco) }}
      </button>
    </div>
  </div>
</div>
